import * as React from 'react';

function SvgNotificationBell(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={21.999} height={25.001} {...props}>
      <g transform="translate(-337 -39)">
        <path
          d="M345.333 62.822a3.993 3.993 0 01-1.028-2.038h-6.612a.7.7 0 01-.677-.556.709.709 0 01.392-.791c2.608-1.2 2.707-6.35 2.709-6.48V49.5a8.045 8.045 0 014.83-7.4 3.053 3.053 0 116.106 0 8.044 8.044 0 014.829 7.4v3.455c0 .13.1 5.28 2.71 6.48a.709.709 0 01.392.791.7.7 0 01-.677.556h-6.612a3.993 3.993 0 01-1.028 2.038 3.606 3.606 0 01-5.334 0zM348 62.59a2.436 2.436 0 002.274-1.807h-4.549A2.435 2.435 0 00348 62.59zm-8.37-3.217h16.739a7.87 7.87 0 01-1.213-2.4h-14.312a7.851 7.851 0 01-1.214 2.4zm1.87-9.873v3.459a15.025 15.025 0 01-.292 2.6h13.583a14.946 14.946 0 01-.293-2.593V49.5a6.5 6.5 0 10-13 0zm8.1-7.862a1.661 1.661 0 00-3.207 0 7.762 7.762 0 013.207 0zm-7 7.733a5.458 5.458 0 015.4-5.5.705.705 0 010 1.41 4.059 4.059 0 00-4.017 4.09.692.692 0 11-1.384 0z"
          data-name="Shape 56"
          fill="#fff"
        />
        <circle
          cx={3.5}
          cy={3.5}
          r={3.5}
          data-name="Ellipse 4"
          transform="translate(351 43)"
          fill="#ff2a82"
        />
      </g>
    </svg>
  );
}

export default SvgNotificationBell;
